import React from "react";

import BackGround from "components/common/BackGround";
import Gnb from "components/common/Gnb";
import Footer from "components/common/Footer";
import Services from "components/service/Services";

export default function Service() {
    return (
        <BackGround>
            <Gnb />
            <Services />
            <Footer />
        </BackGround>
    );
}